import { render } from "./AccessibilityModal.vue?vue&type=template&id=04b78f12"
import script from "./AccessibilityModal.vue?vue&type=script&lang=js"
export * from "./AccessibilityModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__